import { render, staticRenderFns } from "./card-applications.vue?vue&type=template&id=5e5832ab"
import script from "./card-applications.vue?vue&type=script&lang=js"
export * from "./card-applications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports